import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL || 'https://api-csice.fii.gob.ve';

axios.defaults.baseURL = API_URL;
let instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

instance.interceptors.request.use(request => {
    request.headers.common['Accept'] = 'application/json';
    request.headers.common['Content-Type'] = 'application/json';
    request.headers.common = { 'Authorization': `bearer ${sessionStorage.token}` }
    return request;
});

instance.interceptors.response.use(
    response => {
        if (response.data.status) {
            if (response.data.status == 121 || response.data.status == 122) {
                sessionStorage.removeItem('user');
                window.location = 'login';
            }
        }
        return response;
    },
    error => {
        if (error.response.status === 401) {
            sessionStorage.removeItem('user');
            window.location = 'login';
        }

        return Promise.reject(error);
    }
);

export default instance;